import { render, staticRenderFns } from "./CustomDatePicker.vue?vue&type=template&id=63b6f3d2&scoped=true&"
import script from "./CustomDatePicker.vue?vue&type=script&lang=ts&"
export * from "./CustomDatePicker.vue?vue&type=script&lang=ts&"
import style0 from "./CustomDatePicker.vue?vue&type=style&index=0&id=63b6f3d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b6f3d2",
  null
  
)

export default component.exports